import { FC, memo } from 'react'

import { Button, Text } from '@cash-me/react-components'

import { Card } from 'components/card'
import { Grid, Col } from 'components/grid'

import * as S from './styles'

interface PageProps {
  onClick: () => void
}

const PriceRanges: FC<PageProps> = memo(({ onClick: handleMoreInfo }) => (
  <S.Wrapper>
    <Grid col={{ phone: 1, tablet: 12, desktop: 12 }}>
      <Col col={{ tablet: 10, desktop: 10 }} start={{ tablet: 2, desktop: 2 }}>
        <S.PriceRangeContent>
          <Text as="h2" size="heading3" weight="medium">
            Consórcio de Carros{' '}
            <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
              cabe no seu bolso
            </Text>
            ?
          </Text>
          <Text color="var(--colors-neutral-text-default)">Conheça algumas das opções:</Text>
          <S.CardsWrapper>
            <Card border="neutral-border-default">
              <S.CardContent>
                <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                  Crédito de R$ 40 <br />
                  mil
                </Text>
                <Text size="body1" color="var(--neutral-text-default)">
                  Parcelas a partir de
                </Text>
                <Text size="heading4" weight="medium" color="var(--neutral-text-default)">
                  R$ 391,75
                </Text>
                <Button onClick={handleMoreInfo}>Saiba mais</Button>
              </S.CardContent>
            </Card>
            <Card border="neutral-border-default">
              <S.CardContent>
                <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                  Crédito de R$ 61 <br />
                  mil
                </Text>
                <Text size="body1" color="var(--neutral-text-default)">
                  Parcelas a partir de
                </Text>
                <Text size="heading4" weight="medium" color="var(--neutral-text-default)">
                  R$ 597,41
                </Text>
                <Button onClick={handleMoreInfo}>Saiba mais</Button>
              </S.CardContent>
            </Card>
            <Card border="neutral-border-default">
              <S.CardContent>
                <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                  Crédito de R$ 80 <br />
                  mil
                </Text>
                <Text size="body1" color="var(--neutral-text-default)">
                  Parcelas a partir de
                </Text>
                <Text size="heading4" weight="medium" color="var(--neutral-text-default)">
                  R$ 783,49
                </Text>
                <Button onClick={handleMoreInfo}>Saiba mais</Button>
              </S.CardContent>
            </Card>
            <Card border="neutral-border-default">
              <S.CardContent>
                <Text as="h3" size="heading4" weight="medium" color="var(--neutral-text-default)">
                  Crédito de R$ 115 <br />
                  mil
                </Text>
                <Text size="body1" color="var(--neutral-text-default)">
                  Parcelas a partir de
                </Text>
                <Text size="heading4" weight="medium" color="var(--neutral-text-default)">
                  R$ 1.248,81
                </Text>
                <Button onClick={handleMoreInfo}>Saiba mais</Button>
              </S.CardContent>
            </Card>
          </S.CardsWrapper>
        </S.PriceRangeContent>
      </Col>
    </Grid>
  </S.Wrapper>
))

PriceRanges.displayName = 'PriceRanges'

export default PriceRanges
